import { FC } from "react";
import { Link } from "react-router-dom";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";
import __ from "web/Layout/Translations";

import StarsRating from "web/Components/Common/StarsRating";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultStyles from "./review.scss";

interface IPageGeneratorReviewProps {
  url: string;
  title: string;
  name: string;
  rating: number;
  image: string;
  contentText: string;
}

const PageGeneratorReview: FC<PropsWithClasses<IPageGeneratorReviewProps>> = ({
  url,
  title,
  name,
  rating,
  image,
  contentText,
  classes = {},
}) => {
  const ratingProcessed = rating.toFixed(1);
  return (
    <article className={classes.root} data-t1="pageGeneratorReviews__review">
      <div className={classes.row}>
        <div className={classes.preview}>
          <Link
            className={classes.imageBox}
            to={url}
            title={title}
            data-t1="pageGeneratorReviews__reviewLinkImage"
            aria-hidden="true"
            tabIndex={-1}
          >
            <LazyLoadImage
              className={classes.image}
              src={image}
              alt=""
              width={321}
              height={218}
              isProduct
            />
          </Link>
          <h3
            className={classes.title}
            data-t1="pageGeneratorReviews__reviewTitle"
          >
            <Link
              className={classes.link}
              to={url}
              data-t1="pageGeneratorReviews__reviewTitleLink"
              aria-label={`${__("Przejdź do strony produktu")}: ${title}`}
            >
              {title}
            </Link>
          </h3>
        </div>
        <blockquote className={classes.content}>
          <div
            className={classes.rating}
            data-t1="pageGeneratorReviews__reviewRating"
            data-t2={parseInt(`${rating}`, 10)}
          >
            <StarsRating
              className={classes.stars}
              rating={parseInt(`${rating}`, 10)}
            />
            <span className={classes.ratingAmount}>{ratingProcessed}</span>
          </div>
          <p
            className={classes.text}
            data-t1="pageGeneratorReviews__reviewText"
          >
            {contentText}
          </p>
          <cite
            className={classes.name}
            data-t1="pageGeneratorReviews__reviewAuthor"
          >
            {name}
          </cite>
        </blockquote>
      </div>
    </article>
  );
};

export default classify<PropsWithClasses<IPageGeneratorReviewProps>>(
  defaultStyles
)(PageGeneratorReview);
